import React from "react";
import Modal from "react-bootstrap/Modal";

function ConfirmModal(props){
    return <Modal show={props.confirmModal} onHide={props.closeComfirmModal} id="conferma" centered>
        <Modal.Header closeButton>
            <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div className="conferma-modal">
              <span className="icon">
                <i className="fas fa-check"></i>
              </span>
                <span className="message">Piatto aggiunto al carrello</span>
            </div>
        </Modal.Body>
    </Modal>;
}

export default ConfirmModal;